import inventoryService from "../services/inventoryService";

export const GET_STOCK_REPORT = "GET_STOCK_REPORT";
export const GET_STOCK_REPORT_SUCCESS = "GET_STOCK_REPORT_SUCCESS";
export const GET_STOCK_REPORT_ERROR = "GET_STOCK_REPORT_ERROR";

export const GET_INVENTORY_DETAILS = "GET_INVENTORY_DETAILS";
export const GET_INVENTORY_DETAILS_SUCCESS = "GET_INVENTORY_DETAILS_SUCCESS";
export const GET_INVENTORY_DETAILS_ERROR = "GET_INVENTORY_DETAILS_ERROR";

export function getStockReportRecord(query) {
  return async (dispatch) => {
    dispatch(getStockReport());
    return await inventoryService
      .getStockReport(query)

      .then((response) => dispatch(getStockReportSuccess(response)))
      .catch((error) => dispatch(getStockReportError(error)));
  };
}

export function getStockReport() {
  return {
    type: GET_STOCK_REPORT,
  };
}

export function getStockReportSuccess(success) {
  return {
    type: GET_STOCK_REPORT_SUCCESS,
    payload: { success },
  };
}

export function getStockReportError(error) {
  return {
    type: GET_STOCK_REPORT_ERROR,
    payload: { error },
  };
}

export function getInventoryDetailsRecord(query) {
  return async (dispatch) => {
    dispatch(getInventoryDetails());
    return await inventoryService
      .getInventoryDetails(query)

      .then((response) => dispatch(getInventoryDetailsSuccess(response)))
      .catch((error) => dispatch(getInventoryDetailsError(error)));
  };
}

export function getInventoryDetails() {
  return {
    type: GET_INVENTORY_DETAILS,
  };
}

export function getInventoryDetailsSuccess(success) {
  return {
    type: GET_INVENTORY_DETAILS_SUCCESS,
    payload: { success },
  };
}

export function getInventoryDetailsError(error) {
  return {
    type: GET_INVENTORY_DETAILS_ERROR,
    payload: { error },
  };
}
